import { getAudioFormTemplate, getVueAudioFormTemplate } from "../../shortcodes/templates";

let audioFormShortcode = null;
const visualizeAudioForm = content => {
  audioFormShortcode = content.querySelectorAll('[data-wrapper-id="audio-form-shortcode"]');

  if (audioFormShortcode.length > 0) {
    audioFormShortcode.forEach(item => {
      item.innerHTML = getAudioFormTemplate();
    });
  }
};

const serializeAudioForm = content => {
  const audioFormShortcode = content.querySelectorAll('[data-wrapper-id="audio-form-shortcode"]');
  if (audioFormShortcode.length > 0) {
    audioFormShortcode.forEach(item => {
      const audioFormData = item.getAttribute("data-audio-form-data");
      item.innerHTML = getVueAudioFormTemplate(audioFormData);
    });
  }
};

export { visualizeAudioForm, serializeAudioForm };
